
















































import { Component, Vue } from "vue-property-decorator";
import NavIcon from "./navigation/NavIcon.vue";
import { AuthModule } from "@/store/auth.module";
import { AuthService } from "@/services/auth.service";
import InfoQuestionary from "@/components/ui/InfoQuestionary.vue";
import { QuestionareModule } from "@/store/questionary.module";

@Component({
  components: {
    NavIcon,
  }
})
export default class ApNavigation extends Vue {

  get isLoggedIn() {
    return AuthModule.isLoggedIn;
  }

  get user() {
    return AuthModule.user as IUser;
  }

  get userOrgName() {
    return this.user.name;
  }

  goToContracts() {
    this.$router.push("/");
  }

  logout() {
    AuthService.logout();
  }
}
